import axios from "axios";
const BASE = "https://ttrg8xh7o1.execute-api.ap-south-1.amazonaws.com";

export const usersToday = () => axios.get(`${BASE}/users/today`);
export const usersYesterday = () => axios.get(`${BASE}/users/yesterday`);
export const usersLast7 = () => axios.get(`${BASE}/users/last7`);
export const usersLast30 = () => axios.get(`${BASE}/users/last30`);

export const usersMonthlyRange = (params) =>
  axios.get(`${BASE}/users/dashboard/monthly/range`, { params });
